import React from 'react';

const Contact = () => (
  <section className="displayed-content">
    <h2>Contact</h2>
    <p>Pecos Valley Quality Welding</p>
    <p>PO Box 107</p>
    <p>Pecos, NM 87552</p>
    <p><a href="tel:+1-505-470-6758">(505) 470-6758</a><br /></p>
    <p><a href="tel:+1-505-757-2150">(505) 757-2150</a><br /></p>
    <p><a href="mailto:hello@pecosqualitywelding.com">hello@pecosqualitywelding.com</a></p> 
  </section>
);

export default Contact;


// WEBPACK FOOTER //
// ./src/components/ContactMe.js